import { useMemo } from 'react';

import { type Device, useDevice } from '@/api/devices';
import { isScoutDevice } from '@/utils';

const TETHER_DASHBOARD_BASE_URL = 'https://tether.onlineoceans.com';

export const TETHER_URLS = {
    billing: `${TETHER_DASHBOARD_BASE_URL}/billing`,
    telemetry: `${TETHER_DASHBOARD_BASE_URL}/telemetry`,
};

export const useTetherDeviceIdentity = ({ spotterId }: { spotterId?: string | null } = {}): {
    tetherDashboardUrl: string;
    scoutId: number | null | undefined;
    spotterId: string | null;
    isScout: boolean;
    device?: Device;
} => {
    const { data: device } = useDevice({ spotterId });

    return useMemo(() => {
        const scoutId = device?.metadata?.scoutId;
        const tetherDashboardUrl = scoutId
            ? `${TETHER_DASHBOARD_BASE_URL}/?robotId=${scoutId}`
            : TETHER_DASHBOARD_BASE_URL;
        const isScout = isScoutDevice(device?.hullType);

        return { tetherDashboardUrl, scoutId, spotterId: device?.spotterId ?? spotterId ?? null, isScout, device };
    }, [device, spotterId]);
};
